import { useEffect, useState } from "react";

import api from "../../services/api";

// A escolha de empresa acompanha o usuário entre as telas do financeiro, mas
// não é preferência de conta: mora no navegador, não no perfil.
const STORAGE_KEY = 'finance_billing_company';

export const getStoredBillingCompany = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
        return '';
    }
};

export const storeBillingCompany = id => {
    try {
        if (id) {
            localStorage.setItem(STORAGE_KEY, id);
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    } catch (error) {
        // Navegador com storage bloqueado: a escolha vale só nesta tela.
    }
};

export const getBillingCompanyLabel = company => (
    company?.trade_name || company?.company_name || 'Empresa sem nome'
);

/**
 * Empresas de faturamento do tenant (os CNPJs dele).
 *
 * `hasMultiple` é o que decide se o módulo mostra qualquer coisa de empresa:
 * com um CNPJ só — a esmagadora maioria, já que o provisionamento cria
 * exatamente um — nenhum campo, filtro ou coluna nova aparece.
 */
export const useBillingCompanies = () => {
    const [billingCompanies, setBillingCompanies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get(`/finance-billing-company`)
            .then(res => setBillingCompanies(res.data.resources))
            .catch(() => {})
            .then(() => setLoading(false));
    }, []);

    const defaultBillingCompanyId = billingCompanies.find(company => company.is_default_billing_company)?.id
        ?? billingCompanies[0]?.id
        ?? null;

    return {
        billingCompanies,
        hasMultiple: billingCompanies.length > 1,
        defaultBillingCompanyId,
        loading,
    };
};
